/**
 * Service Worker Registration
 * Registers the service worker for offline support and caching
 */

export const registerServiceWorker = async () => {
  // Only register in production
  if (import.meta.env.DEV) {
    if (import.meta.env.DEV) {
      console.log('[SW] Service worker disabled in development');
    }
    return;
  }

  // Check if service workers are supported
  if (!('serviceWorker' in navigator)) {
    if (import.meta.env.DEV) {
      console.log('[SW] Service workers are not supported');
    }
    return;
  }

  try {
    // Register the service worker
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
    });

    if (import.meta.env.DEV) {
      console.log('[SW] Service worker registered:', registration.scope);
    }

    // Check for updates periodically
    setInterval(() => {
      registration.update();
    }, 60 * 60 * 1000); // Check every hour

    // Handle updates
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;

      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New service worker available
            if (import.meta.env.DEV) {
              console.log('[SW] New service worker available');
            }

            // Optionally show update notification to user
            showUpdateNotification(newWorker);
          }
        });
      }
    });
  } catch (error) {
    console.error('[SW] Service worker registration failed:', error);
  }
};

/**
 * Show update notification to user
 * You can customize this to show a toast or modal
 */
const showUpdateNotification = (_worker: ServiceWorker) => {
  // Simple console log for now
  // In production, you might want to show a toast notification
  if (import.meta.env.DEV) {
    console.log('[SW] New version available. Refresh to update.');
  }

  // Optionally auto-update after a delay
  // Uncomment to enable auto-update
  // setTimeout(() => {
  //   worker.postMessage({ type: 'SKIP_WAITING' });
  //   window.location.reload();
  // }, 3000);
};

/**
 * Unregister service worker
 * Useful for debugging or if you want to disable SW
 */
export const unregisterServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
    if (import.meta.env.DEV) {
      console.log('[SW] Service worker unregistered');
    }
  }
};

export default {
  registerServiceWorker,
  unregisterServiceWorker,
};
